import type {
  Attendee,
  AttendeeCreateData,
  AttendeeFeedItem,
} from "../../types/attendee";
import { normalizeWeightKgForPayload } from "../../utils/petWeight";
import { apiUrl } from "../../utils/url";
import type { AttendeeData } from "./types";
import { HttpClient } from "../HttpClient";
import type { IAttendeesService } from "./IAttendeesService";

export class AttendeesService implements IAttendeesService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 10000,
      headers: {},
    });
  }

  async getAttendeeById(id: number): Promise<Attendee> {
    try {
      return await this.httpClient.get<Attendee>(`/attendees/${id}`);
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar os dados do animal. Atualize a página e tente novamente.",
      );
    }
  }

  async getAttendeesByClientId(clientId: number): Promise<AttendeeData[]> {
    try {
      return await this.httpClient.get<AttendeeData[]>(
        `/attendees/client/${clientId}`,
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar os dados do animal. Atualize a página e tente novamente.",
      );
    }
  }

  async createAttendee(attendeeData: AttendeeCreateData): Promise<number> {
    try {
      const payload = {
        ...attendeeData,
        weightKg: normalizeWeightKgForPayload(attendeeData.weightKg),
      };
      const response = await this.httpClient.post<number>(
        "/attendees",
        payload,
        {},
        true,
      );
      return response;
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível criar o animal. Confirme os campos obrigatórios e tente novamente.",
      );
    }
  }

  async updateAttendee(
    id: number,
    attendeeData: Partial<AttendeeCreateData>,
  ): Promise<number> {
    try {
      const payload = {
        ...attendeeData,
        weightKg: normalizeWeightKgForPayload(attendeeData.weightKg),
      };
      return await this.httpClient.put<number>(
        `/attendees/${id}`,
        payload,
        {},
        true,
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível atualizar o animal. Confirme os campos obrigatórios e tente novamente.",
      );
    }
  }

  async getFeed(attendeeId: number): Promise<AttendeeFeedItem[]> {
    try {
      return await this.httpClient.get<AttendeeFeedItem[]>(
        `/attendees/feed?attendeeId=${attendeeId}`,
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar o histórico do animal. Atualize a página e tente novamente.",
      );
    }
  }
}
